export class UpdateWorkspaceLoggingSettingsInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": ""
        },
        {
            "name": "cloudwatchEnabled",
            "baseName": "cloudwatchEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "cloudwatchLogGroupName",
            "baseName": "cloudwatchLogGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "s3Enabled",
            "baseName": "s3Enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "s3Uri",
            "baseName": "s3Uri",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateWorkspaceLoggingSettingsInput.attributeTypeMap;
    }
    constructor() {
    }
}
